// OS-level desktop notification for new finance requests, for when the operator
// has the browser minimized or is in another app (where a backgrounded-tab
// sound may be suspended and the in-app toast is invisible). Complements the
// sound + toast; it does not replace them.
//
// Opt-in is the browser's own permission prompt, requested on first user
// gesture (never nag: asked once). No settings UI.
//
// ponytail: no per-user preference/mute. Add when operators ask.

function canNotify(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

// Request permission once, on the first gesture, only if not yet decided.
if (canNotify()) {
  const ask = (): void => {
    try {
      if (Notification.permission === 'default') void Notification.requestPermission().catch(() => {});
    } catch {
      // ignore
    }
  };
  window.addEventListener('pointerdown', ask, { passive: true, once: true });
  window.addEventListener('keydown', ask, { passive: true, once: true });
}

/**
 * Show a system notification for a new request. No-op unless the browser
 * supports it, permission is granted, and the tab is currently hidden (a
 * visible tab already shows the in-app toast, so a system popup is redundant).
 */
export function notifyDesktop(title: string, body: string, onClick?: () => void): void {
  try {
    if (!canNotify() || Notification.permission !== 'granted' || !document.hidden) return;
    const n = new Notification(title, {
      body,
      tag: 'b1fr0st-finance',
    });
    n.onclick = () => {
      try {
        window.focus();
        onClick?.();
      } finally {
        n.close();
      }
    };
  } catch {
    // ignore — best-effort, never throws into the stream handler
  }
}
